
<template>
    <div class="container pt-4">
        <div class="row align-content-end">

                <div class="col-3 p-1" v-for="item in sectorsVue" :key="item.message">
                    <div class="container align-content-end">
                        <div id="xray-progress" class="progress">
                            <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"  :style="{ width: item.value + '%'}"></div>
                        </div>
                        <p class="text-xray text-left" style="padding:1px">{{ item.name }} : {{item.value}} %</p>

                    </div>
                </div>

        </div>
    </div>
</template>

<script>


    export default{

        props:[
            'sectors'
        ],

        data() {
            return {
                sectorsVue: [],
                valueAutres: 0,
            }
        },

        mounted() {


            this.sectors.forEach(sector =>
            {


                var nameVueTemp = sector.name;
                var valueVueTemp = sector.value;

                valueVueTemp = Math.round(valueVueTemp,0);

                if(valueVueTemp < 2)
                {
                    this.valueAutres += valueVueTemp;
                }
                else{
                    this.sectorsVue.push(
                        {
                            name: nameVueTemp,
                            value: valueVueTemp
                        }
                    );
                }




            });

            this.sectorsVue.push(
                {
                    name: "Autres",
                    value: this.valueAutres,
                }
            );

        },





    }




</script>
